
export const CUSTOM_DATEPICKER_FORMATS = {
    parse: {
        dateInput: ['DD/MM/YYYY', 'DD-MM-YYYY', 'DD.MM.YYYY', 'YYYY/MM/DD', 'YYYY-MM-DD', 'DD-MMM-YYYY'],
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMM YYYY',
        initialisationFormat: "dd.MM.yyyy"
    },
};
